<template>
  <div class="document-brought">
    <div class="document-brought-label">{{ $lang.app.document_brought}}</div>
    <label class="switch" @click="toggleBroughtDocument">
      <input type="checkbox" disabled
             :checked="this.application.broughtDocument">
      <span class="slider round"></span>
    </label>
  </div>
</template>
<script>
export default {
  props: ['application'],
  methods: {
    toggleBroughtDocument() {
      if(!this.application.broughtDocument) {
        this.$swal.fire({
          icon: 'warning',
          text: this.$lang.app.document_brought_confirm_question,
          showDenyButton: true,
          confirmButtonColor: '#4c9ac7',
          denyButtonColor: '#6e7881',
          confirmButtonText: this.$lang.app.yes,
          denyButtonText: this.$lang.app.no,
        }).then((result) => {
          if (result.isConfirmed) {
            this.$store.commit('startLoading')
            this.$axios.get(`/application/${this.application.id}/brought-document`,
                { params: { broughtDocument: true } })
                .then(() => {
                  this.$snotify.success(this.$lang.app.document_brought_on);
                  this.$emit('refresh');
                }).catch(error => {
                  this.$snotify.error(error);
                }).finally(() => {
                  this.$store.commit('stopLoading')
                })
          } else if(result.isDenied) {
            console.log('deny')
          }
        })
      } else {
        this.$store.commit('startLoading')
        this.$axios.get(`/application/${this.application.id}/brought-document`,
            { params: { broughtDocument: false } })
            .then(() => {
              this.$snotify.warning(this.$lang.app.document_brought_off);
              this.$emit('refresh');
            }).catch(error => {
              this.$snotify.error(error);
            }).finally(() => {
              this.$store.commit('stopLoading')
            })
      }
    }
  },
}
</script>
<style>
@import '../../../assets/styles/switch.css';
.document-brought {
  display: flex;
  align-items: center;
  margin: 0 10px;
}
.document-brought-label {
  margin-right: 10px;
}
</style>
